import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/src/shared/lib/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/widgets/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderLayoutWrapper"] */ "/app/src/widgets/header/header-layout-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/widgets/header/header.tsx");
